
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'
import React, { useEffect, useState } from "react";
import { fetchSettingsData } from '../Services/SettingsAPI';

function PrivacyPolicy() {
    const [data, setData] = useState(null);

  useEffect(() => {
    async function loadData() {
      try {
        const result = await fetchSettingsData();
        setData(result);
      } catch (err) {
        console.error("Failed to load data", err);
      }
    }

    loadData();
  }, []);


    return (
        <div>
            <Header />
            <section class="as_breadcrum_wrapper">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <h1>Privacy Policy</h1>

                            <ul class="breadcrumb">
                                <li><a href="/">Home</a></li>
                                <li>Privacy Policy</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section class="as_contact_wrapper as_padderBottom40 as_padderTop50">
                <div class="container">
                {data ? (
            <div dangerouslySetInnerHTML={{ __html: data.privacy_policy.replace(/\n/g, "<br/>").replace(/●/g, "</li><li>")   // replace ● with list item
                .replace(/(Personal Identifiable Information:)/, "<h4>$1</h4><ul>")
                .replace(/(Non-Personal Identifiable Information:)/, "</ul><h4>$1</h4><ul>")
                + "</ul>" }} />
          ) : (
            <p>Loading...</p>
          )}
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PrivacyPolicy